export default __webpack_public_path__ + "resources/icons/n411-9394.png";